import React, { useState, useEffect } from 'react';
import { MenuItem, TextField, IconButton } from '@material-ui/core';
import BookmarkBorderSharpIcon from '@material-ui/icons/BookmarkBorderSharp';
import BookmarkSharpIcon from '@material-ui/icons/BookmarkSharp';

import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { isAddNewField, isEditField } from '../handler/CommonHandler';
import './RenderTagItemSystemMaster.css';
import LoadingPanel from '@/component/common/LoadingPanel';
import localStorageUtil from '@/common/utils/localStorageUtil';
import {
    changeMasterItemCorporationSelected,
    changeMasterItemTypeSelected,
    getMasterItemList,
    changeMasterItemProjectSelected,
    changeMasterItemUserSelected
} from './handler/TagItemSystemMasterHandler';
import { useRecoilState } from 'recoil';
import { panelSettingAtom } from '@/state/atom/panelAtom';
import { cloneDeep } from 'lodash';
import trI18n from '@/common/utils/trI18n';
import { tr, trLabel } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';

const RenderTagItemSystemMaster = ({ currentField, props, indexAddField }) => {
    // Subscribe to translation updates so displayed labels re-render on language change
    useTranslationSubscription();
    // Common state
    const userId = localStorageUtil.getUserDetailId();
    const corporationId = localStorageUtil.getAffiliationOrganization();
    const currentCorporationProjectList = props.projectList;
    const currentCorporationDetail = props.corporationDetail;
    const currentProjectDetail = props.projectDetail;

    // Panel
    const [settingSlideRecoilState, setSettingSlideRecoilState] = useRecoilState(panelSettingAtom);

    const [isLoading, setIsLoading] = useState(false);
    const [activeList, setActiveList] = useState([]);
    const [inactiveList, setInactiveList] = useState([]);
    const [isAutoAddData, setIsAutoAddData] = useState(
        currentField.structure.isAutoAddData ? currentField.structure.isAutoAddData : false
    );
    const [isAutoFill, setIsAutoFill] = useState(
        currentField.structure.isAutoFill ? currentField.structure.isAutoFill : false
    );
    const [masterItemTypeSelected, setMasterItemTypeSelected] = useState(
        currentField.structure.masterItemTypeSelected
            ? currentField.structure.masterItemTypeSelected
            : Constant.MASTER_FIELD_SYSTEM_MASTER_ITEM_TYPE.USER
    );
    const [masterItemCorporationSelected, setMasterItemCorporationSelected] = useState(
        currentField.structure.masterItemCorporationSelected
            ? currentField.structure.masterItemCorporationSelected
            : Constant.MASTER_FIELD_SYSTEM_MASTER_CORPORATION_TYPE.INUSE
    );
    const [masterItemProjectSelected, setMasterItemProjectSelected] = useState(
        currentField.structure.masterItemProjectSelected
            ? currentField.structure.masterItemProjectSelected
            : Constant.MASTER_FIELD_SYSTEM_MASTER_PROJECT_TYPE.INUSE
    );
    const [masterItemUserSelected, setMasterItemUserSelected] = useState(
        currentField.structure.masterItemUserSelected
            ? currentField.structure.masterItemUserSelected
            : Constant.MASTER_FIELD_SYSTEM_MASTER_USER_TYPE.ALL
    );

    const displayOrder = currentField.structure.displayOrder;

    const argsCommon = {
        API: props?.API,
        userId,
        corporationId,
        currentCorporationProjectList,
        currentCorporationDetail,
        currentProjectDetail,
        settingSlideRecoilState,
        setSettingSlideRecoilState,

        isLoading,
        setIsLoading,
        activeList,
        setActiveList,
        inactiveList,
        setInactiveList,
        isAutoAddData,
        setIsAutoAddData,
        isAutoFill,
        setIsAutoFill,
        masterItemTypeSelected,
        setMasterItemTypeSelected,
        masterItemCorporationSelected,
        setMasterItemCorporationSelected,
        masterItemProjectSelected,
        setMasterItemProjectSelected,
        masterItemUserSelected,
        setMasterItemUserSelected
    };

    useEffect(() => {
        if (!currentField.structure.hasOwnProperty('masterItemTypeSelected')) {
            currentField.structure.masterItemTypeSelected =
                Constant.MASTER_FIELD_SYSTEM_MASTER_ITEM_TYPE.USER;
            currentField.structure.masterItemCorporationSelected =
                Constant.MASTER_FIELD_SYSTEM_MASTER_CORPORATION_TYPE.INUSE;
            currentField.structure.masterItemProjectSelected =
                Constant.MASTER_FIELD_SYSTEM_MASTER_PROJECT_TYPE.INUSE;
            currentField.structure.masterItemUserSelected =
                Constant.MASTER_FIELD_SYSTEM_MASTER_USER_TYPE.ALL;
        }
    });

    useEffect(() => {
        setIsLoading(true);
        getMasterItemList(argsCommon)
            .then(itemData => {
                setActiveList(itemData.activeList);
                setInactiveList(itemData.inactiveList);
            })
            .catch(() => {
                setIsLoading(false);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [
        masterItemTypeSelected,
        masterItemCorporationSelected,
        masterItemProjectSelected,
        masterItemUserSelected
    ]);

    const [useButtonCollapse, setUseButtonCollapse] = useState(true);
    const [unUseButtonCollapse, setUnUseButtonCollapse] = useState(true);

    const hanldeUseButtonCollapse = () => {
        if (useButtonCollapse === true) {
            setUseButtonCollapse(false);
        } else {
            setUseButtonCollapse(true);
        }
    };

    const hanldeUnUseButtonCollapse = () => {
        if (unUseButtonCollapse === true) {
            setUnUseButtonCollapse(false);
        } else {
            setUnUseButtonCollapse(true);
        }
    };

    // Update number sort item
    const reOrderItemList = (itemDataList, itemUsingDataList) => {
        let newList = cloneDeep(itemDataList);

        itemUsingDataList.forEach((item, index) => {
            let indexInList = Utils.findIndexInArrayById(item.id, newList);
            if (indexInList !== -1) {
                newList[indexInList].no = index;
            }
        });

        return newList;
    };

    /** handler onChangeUsingItem */
    const onChangeUsingItem = (event, field, isUsingItem) => {
        if (!isEditField(props.currentUpdateField, props)) {
            return;
        }
        let cloneItemList = cloneDeep(currentCorporationProjectList);

        let index = Utils.findIndexInArrayById(field.id, cloneItemList);

        cloneItemList[index].isCheckbox = isUsingItem;

        // item using list
        let itemUsingListClone = cloneDeep(activeList);
        if (isUsingItem) {
            itemUsingListClone.push(field);
        } else {
            itemUsingListClone = Utils.removeItemInArrayById(field.id, itemUsingListClone);
        }

        setActiveList(itemUsingListClone);
        // render order item list
        reOrderItemList(cloneItemList, itemUsingListClone);
    };

    const renderItem = itemData => {
        return (
            <>
                <div className="item-content">
                    <div className="item-name">
                        <div className="item-name-content">
                            <span className="item-setting-name">
                                {masterItemTypeSelected ===
                                Constant.MASTER_FIELD_SYSTEM_MASTER_ITEM_TYPE.USER
                                    ? Utils.getFullNameOfUser(Constant.LANGUAGE_TYPE.JP, itemData)
                                    : trLabel(Utils.getTextByLanguage(
                                          Constant.LANGUAGE_TYPE.JP,
                                          itemData.name
                                      ))}
                            </span>
                        </div>
                    </div>

                    <div className="listWrap-icon list-field-wrap-content">
                        {/* not using item */}
                        {isEditField(currentField, props) && (
                            <span className="listWrap-item">
                                <BookmarkBorderSharpIcon
                                // onClick={(event) =>
                                //     onChangeUsingItem(event, item, argsAll, true)
                                // }
                                />
                            </span>
                        )}

                        {/* using item */}
                        {isEditField(currentField, props) && (
                            <span className="listWrap-item">
                                <BookmarkSharpIcon
                                // onClick={(event) =>
                                //     onChangeUsingItem(event, item, argsAll, false)
                                // }
                                />
                            </span>
                        )}
                    </div>
                </div>
            </>
        );
    };

    const renderActiveItemList = () => {
        return (
            <div className="accordionContent">
                {Utils.isEmptyArray(activeList) && (
                    <div className="text-center">{trI18n('COMMSG001')}</div>
                )}
                {!Utils.isEmptyArray(activeList) && (
                    <div className="lst-formTag">
                        <ul>
                            {activeList.map((item, index) => {
                                return (
                                    <li key={index}>
                                        <div className="lst-number">{index + 1}.</div>
                                        <div className="lst-text">
                                            {masterItemTypeSelected ===
                                            Constant.MASTER_FIELD_SYSTEM_MASTER_ITEM_TYPE.USER
                                                ? Utils.getFullNameOfUser(
                                                        Constant.LANGUAGE_TYPE.JP,
                                                        item
                                                    )
                                                : trLabel(Utils.getTextByLanguage(
                                                        Constant.LANGUAGE_TYPE.JP,
                                                        item.name
                                                    ))}
                                            <div className="item-formTag">
                                                {isEditField(currentField, props) && (
                                                    <IconButton
                                                        className="itemTools"
                                                        // onClick={event =>
                                                        //     onChangeUsingItem(
                                                        //         event,
                                                        //         item,
                                                        //         false
                                                        //     )
                                                        // }
                                                    >
                                                        <img
                                                            src="/assets/image/icon-pin.svg"
                                                            alt=""
                                                        />
                                                    </IconButton>
                                                )}
                                            </div>
                                        </div>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                )}
            </div>
        );
    };

    const renderInactiveItemList = () => {
        return (
            <div className="accordionContent">
                {Utils.isEmptyArray(inactiveList) && (
                    <div className="text-center item-list-system-master-inactive">
                        {trI18n('COMMSG001')}
                    </div>
                )}
                {!Utils.isEmptyArray(inactiveList) && (
                    <div className="lst-formTag">
                        <ul>
                            {inactiveList.map((item, index) => {
                                return (
                                    <>
                                        <li>
                                            <div className="lst-number">{index + 1}.</div>
                                            <div className="lst-text">
                                                {masterItemTypeSelected ===
                                                Constant.MASTER_FIELD_SYSTEM_MASTER_ITEM_TYPE.USER
                                                    ? Utils.getFullNameOfUser(
                                                          Constant.LANGUAGE_TYPE.JP,
                                                          item
                                                      )
                                                    : trLabel(Utils.getTextByLanguage(
                                                          Constant.LANGUAGE_TYPE.JP,
                                                          item.name
                                                      ))}
                                                <div className="item-formTag">
                                                    {isEditField(currentField, props) && (
                                                        <IconButton
                                                            className="itemTools"
                                                            // onClick={event =>
                                                            //     onChangeUsingItem(event, item, true)
                                                            // }
                                                        >
                                                            <img
                                                                src="/assets/image/icon-pin-outline.svg"
                                                                alt=""
                                                            />
                                                        </IconButton>
                                                    )}
                                                </div>
                                            </div>
                                        </li>
                                    </>
                                );
                            })}
                        </ul>
                    </div>
                )}
            </div>
        );
    };

    return (
        <>
            <LoadingPanel isLoading={isLoading} />
            <div className="createCustomize">
                <ul>
                    {/* type */}
                    <li>
                        <label className="createCustomize-label">{trI18n('TAGLB002')}</label>
                        <div className="createCustomize-control">
                            <TextField
                                className="form-control--wrap form-control--hg32"
                                select
                                variant="outlined"
                                SelectProps={{
                                    MenuProps: {
                                        anchorOrigin: {
                                            vertical: 'bottom',
                                            horizontal: 'left'
                                        },
                                        getContentAnchorEl: null,
                                        className: 'selectDrop'
                                    }
                                }}
                                value={masterItemTypeSelected}
                                defaultValue={Constant.MASTER_FIELD_SYSTEM_MASTER_ITEM_TYPE.USER}
                                onChange={event =>
                                    changeMasterItemTypeSelected(event, currentField, argsCommon)
                                }
                                disabled={!isAddNewField(currentField)}
                            >
                                <MenuItem
                                    value={Constant.MASTER_FIELD_SYSTEM_MASTER_ITEM_TYPE.USER}
                                    key={Constant.MASTER_FIELD_SYSTEM_MASTER_ITEM_TYPE.USER}
                                >
                                    {trI18n('TAGLB005')}
                                </MenuItem>
                                <MenuItem
                                    value={Constant.MASTER_FIELD_SYSTEM_MASTER_ITEM_TYPE.PROJECT}
                                    key={Constant.MASTER_FIELD_SYSTEM_MASTER_ITEM_TYPE.PROJECT}
                                >
                                    {trI18n('TAGLB004')}
                                </MenuItem>
                                <MenuItem
                                    value={
                                        Constant.MASTER_FIELD_SYSTEM_MASTER_ITEM_TYPE.CORPORATION
                                    }
                                    key={Constant.MASTER_FIELD_SYSTEM_MASTER_ITEM_TYPE.CORPORATION}
                                >
                                    {trI18n('TAGLB003')}
                                </MenuItem>
                            </TextField>
                        </div>
                    </li>

                    {/* corp */}
                    <li>
                        <label className="createCustomize-label">{trI18n('TAGLB003')}</label>
                        <div className="createCustomize-control">
                            <TextField
                                className="form-control--wrap form-control--hg32"
                                select
                                variant="outlined"
                                SelectProps={{
                                    MenuProps: {
                                        anchorOrigin: {
                                            vertical: 'bottom',
                                            horizontal: 'left'
                                        },
                                        getContentAnchorEl: null,
                                        className: 'selectDrop'
                                    }
                                }}
                                //disabled={!isAddNewField(props.currentUpdateField)}
                                value={masterItemCorporationSelected}
                                defaultValue={
                                    Constant.MASTER_FIELD_SYSTEM_MASTER_CORPORATION_TYPE.INUSE
                                }
                                onChange={event =>
                                    changeMasterItemCorporationSelected(
                                        event,
                                        currentField,
                                        argsCommon
                                    )
                                }
                                disabled={!isAddNewField(currentField)}
                            >
                                <MenuItem
                                    key={Constant.MASTER_FIELD_SYSTEM_MASTER_CORPORATION_TYPE.INUSE}
                                    value={
                                        Constant.MASTER_FIELD_SYSTEM_MASTER_CORPORATION_TYPE.INUSE
                                    }
                                >
                                    {trI18n('TAGBTN006')}
                                </MenuItem>
                                <MenuItem
                                    key={
                                        Constant.MASTER_FIELD_SYSTEM_MASTER_CORPORATION_TYPE
                                            .CUSTOMER
                                    }
                                    value={
                                        Constant.MASTER_FIELD_SYSTEM_MASTER_CORPORATION_TYPE
                                            .CUSTOMER
                                    }
                                >
                                    {trI18n('TAGBTN007')}
                                </MenuItem>
                                <MenuItem
                                    key={
                                        Constant.MASTER_FIELD_SYSTEM_MASTER_CORPORATION_TYPE.SUPPORT
                                    }
                                    value={
                                        Constant.MASTER_FIELD_SYSTEM_MASTER_CORPORATION_TYPE.SUPPORT
                                    }
                                >
                                    {trI18n('TAGBTN008')}
                                </MenuItem>
                            </TextField>
                        </div>
                    </li>
                </ul>
            </div>

            <div className="createCustomize">
                <ul>
                    {/* PROJECT */}
                    {[
                        Constant.MASTER_FIELD_SYSTEM_MASTER_ITEM_TYPE.USER,
                        Constant.MASTER_FIELD_SYSTEM_MASTER_ITEM_TYPE.PROJECT
                    ].includes(masterItemTypeSelected) && (
                        <li>
                            <label className="createCustomize-label">{trI18n('TAGLB004')}</label>
                            <div className="createCustomize-control">
                                <TextField
                                    className="form-control--wrap form-control--hg32"
                                    value={masterItemProjectSelected}
                                    defaultValue={
                                        Constant.MASTER_FIELD_SYSTEM_MASTER_PROJECT_TYPE.INUSE
                                    }
                                    select
                                    variant="outlined"
                                    onChange={event =>
                                        changeMasterItemProjectSelected(
                                            event,
                                            currentField,
                                            argsCommon
                                        )
                                    }
                                    disabled={!isAddNewField(currentField)}
                                >
                                    <MenuItem
                                        key={Constant.MASTER_FIELD_SYSTEM_MASTER_PROJECT_TYPE.ALL}
                                        value={Constant.MASTER_FIELD_SYSTEM_MASTER_PROJECT_TYPE.ALL}
                                    >
                                        {trI18n('TAGBTN009')}
                                    </MenuItem>
                                    <MenuItem
                                        key={Constant.MASTER_FIELD_SYSTEM_MASTER_PROJECT_TYPE.INUSE}
                                        value={
                                            Constant.MASTER_FIELD_SYSTEM_MASTER_PROJECT_TYPE.INUSE
                                        }
                                    >
                                        {trI18n('TAGBTN010')}
                                    </MenuItem>
                                    <MenuItem
                                        key={Constant.PROJECT_TYPE.BASE}
                                        value={Constant.PROJECT_TYPE.BASE}
                                    >
                                        {trI18n('TAGBTN011')}
                                    </MenuItem>
                                    <MenuItem
                                        key={Constant.PROJECT_TYPE.CUSTOMER}
                                        value={Constant.PROJECT_TYPE.CUSTOMER}
                                    >
                                        {trI18n('TAGBTN012')}
                                    </MenuItem>
                                    <MenuItem
                                        key={Constant.PROJECT_TYPE.GENERAL}
                                        value={Constant.PROJECT_TYPE.GENERAL}
                                    >
                                        {trI18n('TAGBTN013')}
                                    </MenuItem>
                                    <MenuItem
                                        key={Constant.PROJECT_TYPE.PRIVATEDESK}
                                        value={Constant.PROJECT_TYPE.PRIVATEDESK}
                                    >
                                        {trI18n('TAGBTN014')}
                                    </MenuItem>
                                    <MenuItem
                                        key={Constant.PROJECT_TYPE.PUBLICDESK}
                                        value={Constant.PROJECT_TYPE.PUBLICDESK}
                                    >
                                        {trI18n('TAGBTN015')}
                                    </MenuItem>
                                    <MenuItem
                                        key={Constant.PROJECT_TYPE.GUEST}
                                        value={Constant.PROJECT_TYPE.GUEST}
                                    >
                                        {trI18n('TAGBTN016')}
                                    </MenuItem>
                                    <MenuItem
                                        key={Constant.PROJECT_TYPE.GUESTDESK}
                                        value={Constant.PROJECT_TYPE.GUESTDESK}
                                    >
                                        {trI18n('TAGBTN017')}
                                    </MenuItem>
                                </TextField>
                            </div>
                        </li>
                    )}

                    {/* user */}
                    {masterItemTypeSelected ===
                        Constant.MASTER_FIELD_SYSTEM_MASTER_ITEM_TYPE.USER && (
                        <li>
                            <label className="createCustomize-label">{trI18n('TAGLB005')}</label>
                            <div className="createCustomize-control">
                                <TextField
                                    className="form-control--wrap form-control--hg32"
                                    value={masterItemUserSelected}
                                    defaultValue={Constant.MASTER_FIELD_SYSTEM_MASTER_USER_TYPE.ALL}
                                    select
                                    variant="outlined"
                                    onChange={event =>
                                        changeMasterItemUserSelected(
                                            event,
                                            currentField,
                                            argsCommon
                                        )
                                    }
                                    disabled={!isAddNewField(currentField)}
                                >
                                    <MenuItem
                                        key={Constant.MASTER_FIELD_SYSTEM_MASTER_USER_TYPE.ALL}
                                        value={Constant.MASTER_FIELD_SYSTEM_MASTER_USER_TYPE.ALL}
                                    >
                                        {trI18n('TAGBTN018')}
                                    </MenuItem>
                                    <MenuItem
                                        key={Constant.MASTER_FIELD_SYSTEM_MASTER_USER_TYPE.GENERAL}
                                        value={
                                            Constant.MASTER_FIELD_SYSTEM_MASTER_USER_TYPE.GENERAL
                                        }
                                    >
                                        {trI18n('TAGBTN019')}
                                    </MenuItem>
                                    <MenuItem
                                        key={Constant.MASTER_FIELD_SYSTEM_MASTER_USER_TYPE.ADMIN}
                                        value={Constant.MASTER_FIELD_SYSTEM_MASTER_USER_TYPE.ADMIN}
                                    >
                                        {trI18n('TAGBTN020')}
                                    </MenuItem>
                                    <MenuItem
                                        key={
                                            Constant.MASTER_FIELD_SYSTEM_MASTER_USER_TYPE
                                                .PROJECT_MANAGER
                                        }
                                        value={
                                            Constant.MASTER_FIELD_SYSTEM_MASTER_USER_TYPE
                                                .PROJECT_MANAGER
                                        }
                                    >
                                        {trI18n('TAGBTN021')}
                                    </MenuItem>
                                    <MenuItem
                                        key={
                                            Constant.MASTER_FIELD_SYSTEM_MASTER_USER_TYPE
                                                .INTERNAL_CUSTOMER
                                        }
                                        value={
                                            Constant.MASTER_FIELD_SYSTEM_MASTER_USER_TYPE
                                                .INTERNAL_CUSTOMER
                                        }
                                    >
                                        {trI18n('TAGBTN023')}
                                    </MenuItem>
                                    <MenuItem
                                        key={
                                            Constant.MASTER_FIELD_SYSTEM_MASTER_USER_TYPE
                                                .B2C_CUSTOMER
                                        }
                                        value={
                                            Constant.MASTER_FIELD_SYSTEM_MASTER_USER_TYPE
                                                .B2C_CUSTOMER
                                        }
                                    >
                                        {trI18n('TAGBTN024')}
                                    </MenuItem>
                                    <MenuItem
                                        key={Constant.MASTER_FIELD_SYSTEM_MASTER_USER_TYPE.GUEST}
                                        value={Constant.MASTER_FIELD_SYSTEM_MASTER_USER_TYPE.GUEST}
                                    >
                                        {trI18n('TAGBTN025')}
                                    </MenuItem>
                                </TextField>
                            </div>
                        </li>
                    )}
                </ul>
            </div>

            <div className="createSwitch-renderTagItemSystemMaster">
                <div className="createSwitch">
                    <p className="createSwitch-text">{trI18n('TAGBTN026')}</p>
                    <div className="switch-check">
                        <input
                            type="checkbox"
                            id={`switch-auto-add-data-${currentField.id}`}
                            defaultChecked={isAutoAddData}
                            onChange={event => {
                                let newStatus = !isAutoAddData;
                                setIsAutoAddData(newStatus);
                                currentField.structure.isAutoAddData = newStatus;
                            }}
                            disabled={!isAddNewField(currentField)}
                        />
                        <label htmlFor={`switch-auto-add-data-${currentField.id}`}></label>
                    </div>
                </div>

                <div className="createSwitch">
                    <p className="createSwitch-text">{trI18n('TAGBTN027')}</p>
                    <div className="switch-check">
                        <input
                            type="checkbox"
                            id={`switch-auto-fill-${currentField.id}`}
                            defaultChecked={isAutoFill}
                            onChange={event => {
                                let newStatus = !isAutoFill;
                                setIsAutoFill(newStatus);
                                currentField.structure.isAutoFill = newStatus;
                            }}
                            disabled={!isAddNewField(currentField)}
                        />
                        <label htmlFor={`switch-auto-fill-${currentField.id}`}></label>
                    </div>
                </div>
            </div>

            <div
                className={
                    !useButtonCollapse ? 'accordionForm accordionForm--show' : 'accordionForm'
                }
            >
                {/* Khi click vào 'div accordionHead' thì 'div accordionForm sẽ add accordionForm--show' */}
                <div className="accordionHead" onClick={hanldeUseButtonCollapse}>
                    <span className="accordionHead-item">
                        <img src="/assets/image/icon-pin.svg" alt="" />
                    </span>
                    <span className="accordionHead-text">
                        {tr('以下のステータスは使用する')} ({activeList.length})
                    </span>
                </div>
                {renderActiveItemList()}
            </div>

            <div
                className={
                    !unUseButtonCollapse ? 'accordionForm accordionForm--show' : 'accordionForm'
                }
            >
                {/* Khi click vào 'div accordionHead' thì 'div accordionForm sẽ add accordionForm--show' */}
                <div className="accordionHead" onClick={hanldeUnUseButtonCollapse}>
                    <span className="accordionHead-item">
                        <img src="/assets/image/icon-pin-outline.svg" alt="" />
                    </span>
                    <span className="accordionHead-text">
                        {tr('以下のステータスは使用しない')} ({inactiveList.length})
                    </span>
                </div>
                {renderInactiveItemList()}
            </div>
        </>
    );
};

export default RenderTagItemSystemMaster;
